import { sources as epcSources } from './_sources.js';
import { exercises as ausbildungPatg1 } from './deutsche-ausbildung-patg1.js';
import { exercises as ausbildungPatg2 } from './deutsche-ausbildung-patg2.js';
import { exercises as hagenBgbAt1 } from './hagen-jura-bgb-at1.js';
import { exercises as hagenBgbAt2 } from './hagen-jura-bgb-at2.js';

export const sources = {
  ...epcSources,
};

export const exercises = [
  ...ausbildungPatg1,
  ...ausbildungPatg2,
  ...hagenBgbAt1,
  ...hagenBgbAt2,
];
